import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      finance: {
        available_payment_systems: {
          header: 'HEADER',
          label: 'LABEL',
          country_groups_header: 'COUNTRY_GROUPS_HEADER',
          add_new_country_group: 'ADD_NEW_COUNTRY_GROUP',
          remove_group_modal: {
            title: 'REMOVE_MODAL_TITLE',
            delete_question: 'REMOVE_MODAL_DELETE_QUESTION',
            answer_yes: 'REMOVE_MODAL_ANSWER_YES',
            answer_no: 'REMOVE_MODAL_ANSWER_NO',
          },
        },
      },
    },
  }));
}
